import { EventEmitter, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DigitalCareerDaysService } from 'app/services/digital-career-days.service';
import * as moment from 'moment';
import _ from 'lodash';
import { ToasterService } from 'angular2-toaster';
var UpdateAvailabilityComponent = /** @class */ (function () {
    function UpdateAvailabilityComponent(dcds, route, toasterService) {
        this.dcds = dcds;
        this.route = route;
        this.toasterService = toasterService;
        this.fullWidth = true;
        this.availabilityChanged = new EventEmitter();
        this.operator = null;
        this.careerDayId = null;
        this.isLoading = false;
        this.originalAvailabilityBody = {
            availability: []
        };
        this.toggle = false;
        this.errorMessage = null;
        this.hoursRange = [
            { key: 0, value: '00' },
            { key: 1, value: '01' },
            { key: 2, value: '02' },
            { key: 3, value: '03' },
            { key: 4, value: '04' },
            { key: 5, value: '05' },
            { key: 6, value: '06' },
            { key: 7, value: '07' },
            { key: 8, value: '08' },
            { key: 9, value: '09' },
            { key: 10, value: '10' },
            { key: 11, value: '11' },
            { key: 12, value: '12' },
            { key: 13, value: '13' },
            { key: 14, value: '14' },
            { key: 15, value: '15' },
            { key: 16, value: '16' },
            { key: 17, value: '17' },
            { key: 18, value: '18' },
            { key: 19, value: '19' },
            { key: 20, value: '20' },
            { key: 21, value: '21' },
            { key: 22, value: '22' },
            { key: 23, value: '23' }
        ];
        this.minutesRange = [
            { key: 0, value: '00' },
            { key: 15, value: '15' },
            { key: 30, value: '30' },
            { key: 45, value: '45' },
        ];
        this.daysRange = [];
        this.availabilityBody = {
            availability: []
        };
        // public availability
        this.selectedDay = null;
        this.selectedStartHour = 9;
        this.selectedStartMinute = 0;
        this.selectedEndHour = 18;
        this.selectedEndMinute = 0;
        this.careerDayId = this.route.snapshot.params.careerDayId || this.route.snapshot.parent.params.careerDayId || null;
    }
    UpdateAvailabilityComponent.prototype.addAvailability = function () {
        console.log(this.selectedDay, this.selectedStartHour, this.selectedStartMinute, this.selectedEndHour, this.selectedEndMinute);
        var start;
        var end;
        start = moment(this.selectedDay).set('hours', this.selectedStartHour).set('minutes', this.selectedStartMinute);
        end = moment(this.selectedDay).set('hours', this.selectedEndHour).set('minutes', this.selectedEndMinute);
        // FIX-ME check dates (start > end && end - start > 30 min)
        // if (start > end && moment(end).diff(start, 'minutes') >= 30) {
        var clone = Object.assign({}, this.availabilityBody);
        clone.availability.push({
            allow_period: {
                start: new Date(start).toISOString(),
                end: new Date(end).toISOString()
            }
        });
        this.availabilityBody.availability = clone.availability;
        this.selectedDay = null;
        // this.errorMessage = null;
        // } else {
        //   if (end <= start) {
        //     // this.toasterService.pop('error', 'Error', 'Start date must be grater than End date');
        //     this.errorMessage = 'Start date must be grater than End date';
        //   } else if (moment(end).diff(start, 'minutes') < 30) {
        //     // this.toasterService.pop('error', 'Error', 'Slot must be equal or grater than 30 minutes');
        //     this.errorMessage = 'Slot must be equal or grater than 30 minutes';
        //   }
        // }
    };
    Object.defineProperty(UpdateAvailabilityComponent.prototype, "checkDates", {
        get: function () {
            var start;
            var end;
            start = moment(this.selectedDay).set('hours', this.selectedStartHour).set('minutes', this.selectedStartMinute);
            end = moment(this.selectedDay).set('hours', this.selectedEndHour).set('minutes', this.selectedEndMinute);
            if (end <= start) {
                // this.toasterService.pop('error', 'Error', 'Start date must be grater than End date');
                this.errorMessage = 'Start date must be grater than End date';
                return true;
            }
            else if (moment(end).diff(start, 'minutes') < 30) {
                // this.toasterService.pop('error', 'Error', 'Slot must be equal or grater than 30 minutes');
                this.errorMessage = 'Slot must be equal or grater than 30 minutes';
                return true;
            }
            else {
                this.errorMessage = null;
                return false;
            }
        },
        enumerable: true,
        configurable: true
    });
    UpdateAvailabilityComponent.prototype.removeAvailability = function (elem) {
        console.log(elem);
        this.availabilityBody.availability = this.availabilityBody.availability.filter(function (a) { return a !== elem; });
    };
    UpdateAvailabilityComponent.prototype.saveAvailability = function () {
        var _this = this;
        this.isLoading = true;
        this.dcds.updateOperatorAvailability(this.careerDayId, this.availabilityBody).subscribe(function (result) {
            console.log(result);
            _this.toasterService.pop('success', 'Success', 'Availability updated successfully');
            _this.isLoading = false;
            _this.availabilityChanged.emit(true);
            _this.ngOnInit();
        }, function (error) {
            _this.toasterService.pop('error', 'Error', 'Something went wrong, please try again later.');
            _this.isLoading = false;
            _this.availabilityChanged.emit(true);
        });
    };
    UpdateAvailabilityComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.isLoading = true;
        this.toggle = false;
        this.availabilityBody.availability = [];
        this.daysRange = [];
        this.dcds.getOperator(this.careerDayId).subscribe(function (result) {
            _this.operator = result;
            //
            if (result.availability) {
                // this.originalAvailabilityBody.availability = result.availability;
                // this.availabilityBody.availability = result.availability;
                _this.originalAvailabilityBody = {
                    availability: result.availability.slice()
                };
                _this.availabilityBody = {
                    availability: result.availability.slice()
                };
            }
            _this.isLoading = false;
        }, function (error) {
            console.log(error);
            _this.isLoading = false;
        });
        this.dcds.startDate = this.dcds.startDate;
        this.dcds.endDate = this.dcds.endDate;
        var a = new Date(this.dcds.startDate);
        var b = new Date(this.dcds.endDate);
        while (a <= b) {
            this.daysRange.push({
                key: a, value: moment(a).format('D MMM')
            });
            a = moment(a).add(1, 'day').toDate();
        }
    };
    Object.defineProperty(UpdateAvailabilityComponent.prototype, "nothingChanged", {
        get: function () {
            // return
            // const sameLength: boolean = this.availabilityBody.availability.length === this.originalAvailabilityBody.availability.length;
            return _.isEqual(this.availabilityBody, this.originalAvailabilityBody);
        },
        enumerable: true,
        configurable: true
    });
    return UpdateAvailabilityComponent;
}());
export { UpdateAvailabilityComponent };
